<template>
    <fragment>
        <c-hero-split image-fill class="illustration-section-01" />
        <!-- <c-features-tiles /> -->
        <c-features-split invert-mobile image-fill class="illustration-section-05" />
        <c-pricing pricing-switcher class="illustration-section-03" />
        <c-testimonial class="illustration-section-03" />


        <c-generic-section top-divider>
            <div id="faq" class="container-xs">
                <c-section-header :data="FAQHeader" class="center-content" />
                <c-accordion>
                    <c-accordion-item title="What is included in the membership?" active>
                        Our membership is all inclusive so you will get access to all of our premium indicators on TradingView. Our indicators receive updates regularly and we do not charge for updates.
                    </c-accordion-item>
                    <c-accordion-item title="Can I get a free trial?">
                        Yes! We are so confident that you will enjoy our premium indicators that we are offering a 7-day free trial.
                    </c-accordion-item>
                    <c-accordion-item title="What markets and timeframes can I use these indicators on?">
                        You can use Smart Algo indicators on any market and timeframe that is supported by TradingView such as 1 minute, 1 hour, or 1 day. They are a great fit for any one that is looking to do swing trading, scalping, or even longer term trading strategies.
                    </c-accordion-item>
                    <c-accordion-item title="Do you guarantee that I can make money with Smart Algo?">
                        We aim to provide the best indicator suite possible but we do not guarantee any performance or returns. These indicators are meant to be used as part of a discretionary trading system where the trader reviews all information and exercises their trade using their best judgement.
                    </c-accordion-item>
                    <c-accordion-item title="Can Smart Algo be used by a beginner?">
                        Absolutely! Our indicators are very easy to add to the chart and very simple to use. We also have tutorials to help you get setup and live support on our Discord community.
                    </c-accordion-item>
                    <c-accordion-item title="Do I need the premium version of TradingView?">
                        Smart Algo works great on the free version of TradingView, there is no need to upgrade your TradingView.
                    </c-accordion-item>
                </c-accordion>
            </div>
        </c-generic-section>

        <c-cta top-divider bottom-divider split />
    </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue'
// import sections
import CHeroSplit from '@/components/sections/HeroSplit.vue'
import CFeaturesSplit from '@/components/sections/FeaturesSplit.vue'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
import CPricing from '@/components/sections/Pricing.vue'
import CTestimonial from '@/components/sections/Testimonial.vue'
import CGenericSection from '@/components/sections/GenericSection.vue'
import CAccordion from '@/components/elements/Accordion.vue'
import CAccordionItem from '@/components/elements/AccordionItem.vue'
import CCta from '@/components/sections/Cta.vue'

export default {
  name: 'Home',
  components: {
    CHeroSplit,
    CFeaturesSplit,
    CSectionHeader,
    CGenericSection,
    CTestimonial,
    CPricing,
    CCta,
    CAccordion,
    CAccordionItem,
  },
  data() {
    return {
      FAQHeader: {
        title: 'Frequently Asked Questions'
      },
      demoModalActive: false
    }
  },
  created() {
    this.$emit('update:layout', CLayout)
  }
}
</script>
